// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/call-signs.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/call-signs/call-signs.js';

mount([g0]);
